import { render, staticRenderFns } from "./coupons_list.vue?vue&type=template&id=06be2f88&scoped=true&"
import script from "./coupons_list.vue?vue&type=script&lang=js&"
export * from "./coupons_list.vue?vue&type=script&lang=js&"
import style0 from "./coupons_list.vue?vue&type=style&index=0&id=06be2f88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06be2f88",
  null
  
)

export default component.exports